// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import {AuditMixin, AuditMixinAttributes, AuditMixinRelationships} from "./audit-mixin";
import {LIST_RELATIONSHIP_TYPE, SINGLE_RELATIONSHIP_TYPE, DEFAULT} from "./shared-types";

export class FolderAttributes extends AuditMixinAttributes {
    name: string;
    description?: string;
    order: number;
}

export class FolderRelationships extends AuditMixinRelationships {
    session_states: LIST_RELATIONSHIP_TYPE;
    parent: SINGLE_RELATIONSHIP_TYPE = DEFAULT.SINGLE;
}

export class Folder extends AuditMixin {
    attributes: FolderAttributes;
    id: string;
    type: string = 'folder';
    relationships: FolderRelationships;

    constructor() {
        super();
        this.attributes = new FolderAttributes();
        this.relationships = new FolderRelationships();
    }
}

// Sparse JSON:API patch payload — only fields being changed are present.
// Plain interface (not a class) so callers build literals without picking up default attribute/relationship values.
export interface FolderPatch {
    id: string;
    type: 'folder';
    attributes?: Partial<FolderAttributes>;
    relationships?: Partial<FolderRelationships>;
}
